export const SUBJECT_MARGIN_RIGHT = 8

export const SUBJECT_OVERFLOW_GAP = 5

export const FILES_VISIBLE_COUNT = 3
